import * as React from "react"
import '../styles/main.scss'
import NavigationBar from "../components/Navigationbar";
import ContentWrapper from "../components/ContentWrapper";

import LOGO3DE from "../../static/navigation/logo-3de.png";
import TargiMieszkanIDomowLogo from "../../static/navigation/tmid-logo.png";
import NowyAdresLogo from "../../static/navigation/nowyadres-logo.png";

const IndexPage = () => {
  return (
    <main>
      <div className="main-container">
        <NavigationBar images={{left: LOGO3DE, center: TargiMieszkanIDomowLogo, right: NowyAdresLogo}} />
        <ContentWrapper />
      </div>
    </main>
  )
}

export default IndexPage
